import * as React from "react";
import { PrimarySkeleton } from "Components/Shared/PrimarySkeleton";
import styled from "styled-components";

type Props = {
  rowsCount: number;
  columnsCount: number;
};

const StyledSkeleton = styled(PrimarySkeleton)`
  margin-bottom: ${props => props.theme.spacing(0.5)}px;
`;

export const TableSkeleton: React.FunctionComponent<Props> = props => {
  const rows = () => {
    let result: number[] = [];
    for (let index = 0; index < props.rowsCount; index++) {
      result.push(index);
    }
    return result;
  };

  return (
    <>
      {rows().map((x, i) => (
        <tr key={i}>
          <td colSpan={props.columnsCount}>
            <StyledSkeleton height={48} variant={"rect"} />
          </td>
        </tr>
      ))}
    </>
  );
};
